import * as React from "react";
import { createComponent } from "@lit-labs/react";
import {
  ViedocButton,
  ViedocRadio,
  ViedocButtonLink,
  ViedocSpinner,
  ViedocSelect,
  ViedocCheckbox,
  ViedocTextfield,
  ViedocTextarea,
  ViedocDialog,
  ViedocToaster,
  ViedocSidepanelMenuItem,
  ViedocSidepanel,
} from "@viedoc/viedoc-ui";
import "@viedoc/viedoc-ui";
import "@viedoc/viedoc-ui/css/viedoc.css";

export const ViedocCheckboxElement = createComponent({
  tagName: "viedoc-checkbox",
  elementClass: ViedocCheckbox,
  react: React,
  events: {
    onChange: "change",
  },
});

export const ViedocButtonElement = createComponent({
  tagName: "viedoc-button",
  elementClass: ViedocButton,
  react: React,
  events: {
    onClick: "click",
  },
});

export const ViedocSpinnerElement = createComponent({
  tagName: "viedoc-spinner",
  elementClass: ViedocSpinner,
  react: React,
});

export const ViedocRadioElement = createComponent({
  tagName: "viedoc-radio",
  elementClass: ViedocRadio,
  react: React,
  events: {
    onChange: "change",
  },
});

export const ViedocButtonLinkElement = createComponent({
  tagName: "viedoc-button-link",
  elementClass: ViedocButtonLink,
  react: React,
  events: {
    onClick: "click",
  },
});

export const ViedocSelectElement = createComponent({
  tagName: "viedoc-select",
  elementClass: ViedocSelect,
  react: React,
  events: {
    onChange: "change",
  },
});

export const ViedocMenuItemElement = createComponent({
  tagName: "viedoc-menu-item",
  elementClass: ViedocSelect,
  react: React,
  events: {
    onClick: "click",
  },
});

export const ViedocTextfieldElement = createComponent({
  tagName: "viedoc-textfield",
  elementClass: ViedocTextfield,
  react: React,
  events: {
    onChange: "change",
  },
});

export const ViedocTextareaElement = createComponent({
  tagName: "viedoc-textarea",
  elementClass: ViedocTextarea,
  react: React,
  events: {
    onChange: "change",
  },
});

export const ViedocDialogElement = createComponent({
  tagName: "viedoc-dialog",
  elementClass: ViedocDialog,
  react: React,
  events: {
    onHide: "dialog-hide",
    onClick: "click",
  },
});

export const ViedocSidepanelElement = createComponent({
  tagName: "viedoc-sidepanel",
  elementClass: ViedocSidepanel,
  react: React,
  events: {
    onClick: "click",
  },
});

export const ViedocSidepanelMenuItemElement = createComponent({
  tagName: "viedoc-sidepanel-menu-item",
  elementClass: ViedocSidepanelMenuItem,
  react: React,
  events: {
    onClick: "click",
  },
});
export const ViedocToasterElement = createComponent({
  tagName: "viedoc-toaster",
  elementClass: ViedocToaster,
  react: React,
  events: {
    onClick: "click",
  },
});
